import BasicRepository from "./basicRepository";
import Client from "../client";
import {UserRoleResource} from "../resources/userRoleResource";

class UserRoleRepository extends BasicRepository<UserRoleResource> {
    constructor(client: Client) {
        super("UserRoles", client);
    }
}

export default UserRoleRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/userRoleRepository.ts